import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
export default function Navbar() {
  const location = useLocation();
  const path = location.pathname;
  const isActive = (route) => path === route;
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#050505]/80 border-b border-white/10 shadow-[0_4px_30px_rgba(0,0,0,0.8)] transition-all duration-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 font-display font-bold text-xl tracking-tight text-white group" data-testid="landing-logo">
          <div className="size-9 bg-gradient-to-br from-[#FF3B30] to-[#B81D14] grid place-items-center font-bold text-lg text-white shadow-[0_0_15px_rgba(255,59,48,0.4)] group-hover:scale-105 transition-transform">
            Q
          </div>
          <span>QR<span className="text-[#FF3B30]">.</span>NEXUS</span>
        </Link>
        
        <nav className="hidden md:flex items-center gap-1 bg-white/5 border border-white/10 px-6 py-2 rounded-full text-sm font-medium backdrop-blur-md">
          <Link
            to="/"
            className={`px-4 py-1.5 rounded-full transition-all ${
              isActive("/")
                ? "bg-[#FF3B30]/10 text-[#FF3B30] border border-[#FF3B30]/30 font-semibold shadow-[0_0_10px_rgba(255,59,48,0.2)]"
                : "text-white/70 hover:text-white hover:bg-white/5"
            }`}
          >
            Home
          </Link>
          <Link
            to="/pricing"
            className={`px-4 py-1.5 rounded-full transition-all ${
              isActive("/pricing")
                ? "bg-[#FF3B30]/10 text-[#FF3B30] border border-[#FF3B30]/30 font-semibold shadow-[0_0_10px_rgba(255,59,48,0.2)]"
                : "text-white/70 hover:text-white hover:bg-white/5"
            }`}
          >
            Pricing
          </Link>
          <Link
            to="/docs"
            className={`px-4 py-1.5 rounded-full transition-all ${
              isActive("/docs")
                ? "bg-[#FF3B30]/10 text-[#FF3B30] border border-[#FF3B30]/30 font-semibold shadow-[0_0_10px_rgba(255,59,48,0.2)]"
                : "text-white/70 hover:text-white hover:bg-white/5"
            }`}
          >
            Docs
          </Link>
          <Link
            to="/contact"
            className={`px-4 py-1.5 rounded-full transition-all ${
              isActive("/contact")
                ? "bg-[#FF3B30]/10 text-[#FF3B30] border border-[#FF3B30]/30 font-semibold shadow-[0_0_10px_rgba(255,59,48,0.2)]"
                : "text-white/70 hover:text-white hover:bg-white/5"
            }`}
          >
            Contact
          </Link>
        </nav>
        <div className="flex items-center gap-4">
          <Button asChild className="bg-gradient-to-r from-[#FF3B30] to-[#D63026] hover:from-[#E02E24] hover:to-[#B81D14] text-white px-6 h-11 text-sm font-medium tracking-wide shadow-[0_0_20px_rgba(255,59,48,0.3)] hover:shadow-[0_0_25px_rgba(255,59,48,0.6)] transition-all duration-300 border border-[#FF3B30]/40">
            <Link to="/login" data-testid="nav-login">Sign in <ArrowRight className="ml-2 size-4" /></Link>
          </Button>
        </div>
      </div>
    </header>
  );
}
